import { ConinoData, saveConinoData } from '../storage.js'

const module = {
    namespaced: true,
    state: () => ({
        token: ConinoData.auth_token ? ConinoData.auth_token : '',
        // name: '',
        // avatar: '',
        user: ConinoData.auth_user ? ConinoData.auth_user : {},
        wxUser: ConinoData.wx_user ? ConinoData.wx_user : {},
        roles: ConinoData.auth_roles ? ConinoData.auth_roles : [], // 这里的roles对应接口返回的menus
    }),
    getters: {
        getToken: state => {
            return state.token
        },
        isLogined: state => {
            return !!state.token
        },
        wxUser: state => {
            return state.wxUser
        },
        hasWxUser: state => {
            return !!state.wxUser.openid
        }
    },
    mutations: {
        setToken: (state, value) => {
            state.token = value || ''
        },
        setUser: (state, value) => {
            state.user = value || {}
        },
        setWxUser: (state, value) => {
            state.wxUser = value || {}
        },
        setRoles: (state, value) => {
            state.roles = value || []
        }
    },
    actions: {
        setToken: ({ commit }, value) => {
            return new Promise((resolve) => {
                saveConinoData('auth_token', value)
                commit('setToken', value)
                resolve()
            })
        },
        setUser: ({ commit }, value) => {
            saveConinoData('auth_user', value)
            commit('setUser', value)
        },
        setWxUser: ({ commit }, value) => {
            saveConinoData('wx_user', value)
            commit('setWxUser', value)
        },
        setRoles: ({ commit }, value) => {
            let roles = []
            for (let i = 0; i < value.length; i++) {
                const item = value[i];
                roles.push(item.name)
            }
            saveConinoData('auth_roles', roles)
            commit('setRoles', roles)
        },
        logout: ({ commit }, value) => {
            return new Promise((resolve) => {
                saveConinoData('auth_token')
                commit('setToken')
                saveConinoData('auth_roles')
                commit('setRoles')
                saveConinoData('auth_user')
                commit('setUser')
                saveConinoData('wx_user')
                commit('setWxUser')
                resolve()
            })
        }
    },
}

export default module
